import { reactive, readonly } from "vue";
import { ASSISTENT_API_URL } from "@/config/backend"
import axios from "axios";
import authModule from "../auth";

const state = reactive({
    languages: [],
    sttLanguages: [],
    voices: [],
    personas: [],
});

const retrievePersona = async (lang) => {
    const url = ASSISTENT_API_URL + "configuration/personas/" + lang;

    return axios
        .get(url, { headers: authModule.getters.getApiHeaders() })
        .then((response) => {
            if (response.data.errorCode === null) {
                state.personas[lang] = response.data.resultObject.personas;
            }

        });
}

const retrieveGlobalConfiguration = async () => {
    const url = ASSISTENT_API_URL + "configuration/global";

    return axios
        .get(url, { headers: authModule.getters.getApiHeaders() })
        .then((response) => {
            if (response.data.errorCode === null) {
                state.languages = response.data.resultObject.availableLanguages;
                state.sttLanguages = response.data.resultObject.availableSttLanguages;
                state.voices = response.data.resultObject.availableVoices;
            }
        });
}

const actions = {
    initBaseConfiguration: async () => {
        await retrieveGlobalConfiguration();

        await Promise.all(
            state.languages.map((lang) => retrievePersona(lang))
        );
    }
}

const getters = {
    getPersonas: (lang) => {
        return state.personas[lang];
    }
}

const configurationModule = {
    state: readonly(state),
    actions,
    getters
}

export default configurationModule;